<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2>Current Inventory</h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-5">
                    <div class="card p-3">
                        <div class="card-header bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">Current Inventory</h5>
                                </div>
                            </div>
                        </div>
                        <span class="round mt-2"><img src="@/assets/img/vector/download.png" alt /></span>
                        <h4><i aria-hidden="true" class="fa fa-arrow-circle-right"></i> INFORMATION </h4>
                        <p>Fetch the current inventory list with the specified spread</p>

                        <form class="mt-4">
                            <div class="form-row settings justify-content-center">
                                <!-- <div class="form-group col-md-6">
                                    <label for="inputEmail4">Settlement From</label>
                                    <datepicker 
                                        v-model="settilementDateFrom" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Settlement To </label>
                                    <datepicker 
                                        v-model="settilementDateTo" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div> -->
                                <div class="form-group col-md-8 d-flex">
                                    <input type="text" class="form-control" placeholder="spread" v-model="spread"/>
                                    <div class="form-check ml-2 d-flex align-items-center" style="width: 300px;">
                                        <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="takeImsPrice" >
                                        <label for="checkbox2" class="form-check-label mt-1 ml-1">@IMS Offering Prices</label>
                                    </div>
                                </div> 
                                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                <div class="form-group col-md-12 text-center">
                                    <!-- <button type="button" class="btn btn-light">RESET</button> -->
                                    <button :disabled="!spread && !takeImsPrice" @click="exportData()" type="button" class="btn btn-success">EXPORT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import authService from "@/authService";
import config from "@/config";
// import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsComponent",
  components : {
    //   Datepicker
  },
  data() {
    return {
        settilementDateFrom :null,
        settilementDateTo :null,
        loading : false,
        disabledDates: {
          to: this.getYestedayDate()
        },
        spread : "",
        takeImsPrice : false

    };
  },
  methods: { 

    exportData(){
        this.loading = true;
        //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
        // let fromDate = this.settilementDateFrom ? this.moment(this.settilementDateFrom).format("MM/DD/YYYY")  : "" ;
        // let toDate = this.settilementDateTo ? this.moment(this.settilementDateTo).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/excel/spread-inventory-holding?cognitoSub="+authService.getUser().cognitoSub+"&spread="+this.spread +"&takeImsPrice="+this.takeImsPrice,
            auth
        )
        .then((response) => {
            this.loading = false;
            if(response.data){
                window.open(response.data, "_blank");
            }
        }).catch(() => this.loading = false)     

    }
  },
  mounted() {

    this.settilementDateFrom = this.moment().format("MM-DD-YYYY");
    this.settilementDateTo = this.moment().format("MM-DD-YYYY");

    
  }
};
</script>